import { useState } from 'react';
import { tenant as tenantApi } from '../services/api';

const SECTORES = [
  { value: 'inmobiliaria',  label: '🏠 Inmobiliaria' },
  { value: 'formacion',     label: '🎓 Academia / Formación' },
  { value: 'clinica',       label: '💆 Clínica / Estética / Salud' },
  { value: 'ecommerce',     label: '🛒 E-commerce / Tienda' },
  { value: 'restaurante',   label: '🍽️ Restaurante / Hostelería' },
  { value: 'viajes',        label: '✈️ Viajes / Turismo' },
  { value: 'reclutamiento', label: '💼 Reclutamiento / RRHH' },
  { value: 'servicios',     label: '⚙️ Servicios profesionales' },
  { value: 'otro',          label: '📋 Otro' },
];

const OBJETIVOS = [
  { value: 'cualificar_leads',   label: 'Cualificar y captar leads' },
  { value: 'gestionar_citas',    label: 'Gestionar citas y reservas' },
  { value: 'atencion_cliente',   label: 'Atención al cliente 24/7' },
  { value: 'ventas',             label: 'Apoyar el proceso de ventas' },
  { value: 'soporte_tecnico',    label: 'Soporte técnico a clientes' },
];

const s = {
  wrap: {
    minHeight: '100vh', background: '#0a0e0f',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    padding: '24px', fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  card: {
    background: '#0f1517', border: '1px solid #1e2f32',
    borderRadius: '16px', padding: '48px 44px',
    width: '100%', maxWidth: '560px',
  },
  logo: { color: '#7c4dff', fontSize: '22px', fontWeight: 800, marginBottom: '32px', display: 'block' },
  steps: {
    display: 'flex', gap: '8px', marginBottom: '36px',
  },
  stepDot: (active, done) => ({
    flex: 1, height: '4px', borderRadius: '2px',
    background: done ? '#7c4dff' : active ? '#7c4dff' : '#1e2f32',
    opacity: done ? 1 : active ? 1 : 0.4,
    transition: 'all .3s',
  }),
  stepLabel: {
    fontSize: '11px', color: '#4d6a6e', textTransform: 'uppercase',
    letterSpacing: '1.5px', marginBottom: '8px',
  },
  title: {
    fontSize: '24px', fontWeight: 800, color: '#e8f0f1',
    marginBottom: '6px', letterSpacing: '-0.5px',
  },
  subtitle: { fontSize: '14px', color: '#8aa5a9', marginBottom: '28px', lineHeight: 1.6 },
  label: { display: 'block', fontSize: '13px', color: '#8aa5a9', marginBottom: '6px', fontWeight: 500 },
  input: {
    width: '100%', background: '#141c1e', border: '1px solid #1e2f32',
    borderRadius: '8px', padding: '11px 14px', color: '#e8f0f1',
    fontSize: '14px', outline: 'none', marginBottom: '18px', boxSizing: 'border-box',
    transition: 'border-color .15s',
  },
  select: {
    width: '100%', background: '#141c1e', border: '1px solid #1e2f32',
    borderRadius: '8px', padding: '11px 14px', color: '#e8f0f1',
    fontSize: '14px', outline: 'none', marginBottom: '18px', boxSizing: 'border-box',
    cursor: 'pointer',
  },
  textarea: {
    width: '100%', background: '#141c1e', border: '1px solid #1e2f32',
    borderRadius: '8px', padding: '11px 14px', color: '#e8f0f1',
    fontSize: '14px', outline: 'none', marginBottom: '18px', boxSizing: 'border-box',
    resize: 'vertical', minHeight: '96px', lineHeight: 1.6,
    fontFamily: 'system-ui, -apple-system, sans-serif',
  },
  btnRow: { display: 'flex', gap: '12px', marginTop: '8px' },
  btnPrimary: {
    flex: 1, padding: '13px 24px', background: '#7c4dff', color: '#fff',
    border: 'none', borderRadius: '8px', fontWeight: 700, fontSize: '15px',
    cursor: 'pointer', transition: 'background .15s',
  },
  btnSecondary: {
    padding: '13px 20px', background: 'transparent', color: '#8aa5a9',
    border: '1px solid #1e2f32', borderRadius: '8px', fontWeight: 600,
    fontSize: '14px', cursor: 'pointer',
  },
  hint: { fontSize: '12px', color: '#4d6a6e', marginTop: '-14px', marginBottom: '18px' },
  codeBox: {
    background: '#0a0e0f', border: '1px solid #1e2f32', borderRadius: '8px',
    padding: '16px', fontFamily: 'monospace', fontSize: '12px', color: '#00e5a0',
    marginBottom: '18px', wordBreak: 'break-all', lineHeight: 1.7,
    cursor: 'pointer', position: 'relative',
  },
  copyHint: { fontSize: '12px', color: '#4d6a6e', marginBottom: '24px' },
  successIcon: {
    width: '64px', height: '64px', borderRadius: '50%',
    background: 'rgba(0,229,160,0.1)', border: '2px solid rgba(0,229,160,0.3)',
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    fontSize: '28px', margin: '0 auto 24px',
  },
  summaryRow: {
    display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    padding: '10px 0', borderBottom: '1px solid #1e2f32',
    fontSize: '13px',
  },
  summaryKey: { color: '#8aa5a9' },
  summaryVal: { color: '#e8f0f1', fontWeight: 600 },
  error: { color: '#ff6b6b', fontSize: '13px', marginBottom: '12px' },
};

export default function Onboarding({ tenantId, onComplete }) {
  const [step, setStep] = useState(1);
  const [copied, setCopied] = useState(false);
  const [saving, setSaving] = useState(false);
  const [err, setErr] = useState('');

  const [form, setForm] = useState({
    nombre_empresa:  '',
    sector:          '',
    zona_geografica: '',
    nombre_agente:   '',
    objetivo:        '',
    business_context: '',
  });

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const widgetSnippet = `<script src="https://devit.es/widget.js"
  data-tenant="${tenantId}"
  data-pos="bottom-right">
</script>`;

  const handleCopy = () => {
    navigator.clipboard.writeText(widgetSnippet);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const validateStep1 = () => {
    if (!form.nombre_empresa.trim()) return 'Escribe el nombre de tu empresa';
    if (!form.sector) return 'Elige un sector';
    if (!form.zona_geografica.trim()) return 'Indica la zona geográfica';
    return '';
  };

  const validateStep2 = () => {
    if (!form.nombre_agente.trim()) return 'Pon un nombre a tu agente';
    if (!form.objetivo) return 'Elige el objetivo principal';
    if (!form.business_context.trim()) return 'Describe brevemente tu negocio';
    return '';
  };

  const goNext = () => {
    setErr('');
    if (step === 1) {
      const e = validateStep1();
      if (e) { setErr(e); return; }
    }
    if (step === 2) {
      const e = validateStep2();
      if (e) { setErr(e); return; }
    }
    setStep(s => s + 1);
  };

  const handleFinish = async () => {
    setSaving(true);
    setErr('');
    try {
      await tenantApi.setup(form);
      onComplete();
    } catch {
      setErr('Error al guardar. Inténtalo de nuevo.');
    } finally {
      setSaving(false);
    }
  };

  const sectorLabel = SECTORES.find(s => s.value === form.sector)?.label || '';
  const objetivoLabel = OBJETIVOS.find(o => o.value === form.objetivo)?.label || '';

  return (
    <div style={s.wrap}>
      <div style={s.card}>
        <span style={s.logo}>✦ devit</span>

        {/* Barra de progreso */}
        <div style={s.steps}>
          {[1, 2, 3, 4].map(n => (
            <div key={n} style={s.stepDot(step === n, step > n)} />
          ))}
        </div>

        {/* ── PASO 1: Tu negocio ── */}
        {step === 1 && (
          <>
            <p style={s.stepLabel}>Paso 1 de 4</p>
            <h1 style={s.title}>Cuéntanos tu negocio</h1>
            <p style={s.subtitle}>El agente usará esta información para presentarse y responder correctamente.</p>

            <label style={s.label}>Nombre de la empresa *</label>
            <input
              style={s.input}
              placeholder="Ej: Inmobiliaria García, Clínica Dental Pérez..."
              value={form.nombre_empresa}
              onChange={e => set('nombre_empresa', e.target.value)}
            />

            <label style={s.label}>Sector *</label>
            <select style={s.select} value={form.sector} onChange={e => set('sector', e.target.value)}>
              <option value=''>Selecciona un sector...</option>
              {SECTORES.map(sec => (
                <option key={sec.value} value={sec.value}>{sec.label}</option>
              ))}
            </select>

            <label style={s.label}>Zona geográfica *</label>
            <input
              style={s.input}
              placeholder="Ej: Madrid centro, Barcelona, Sevilla..."
              value={form.zona_geografica}
              onChange={e => set('zona_geografica', e.target.value)}
            />
            <p style={s.hint}>El agente mencionará esta zona al cualificar leads o responder consultas.</p>

            {err && <p style={s.error}>{err}</p>}
            <div style={s.btnRow}>
              <button style={s.btnPrimary} onClick={goNext}>Siguiente →</button>
            </div>
          </>
        )}

        {/* ── PASO 2: Tu agente ── */}
        {step === 2 && (
          <>
            <p style={s.stepLabel}>Paso 2 de 4</p>
            <h1 style={s.title}>Personaliza tu agente</h1>
            <p style={s.subtitle}>Dale nombre y propósito. Así sabe cómo presentarse y qué priorizar en cada conversación.</p>

            <label style={s.label}>Nombre del agente *</label>
            <input
              style={s.input}
              placeholder="Ej: Sofía, Devit, Asistente..."
              value={form.nombre_agente}
              onChange={e => set('nombre_agente', e.target.value)}
            />
            <p style={s.hint}>El cliente verá este nombre cuando interactúe con el chatbot.</p>

            <label style={s.label}>Objetivo principal *</label>
            <select style={s.select} value={form.objetivo} onChange={e => set('objetivo', e.target.value)}>
              <option value=''>Selecciona el objetivo...</option>
              {OBJETIVOS.map(o => (
                <option key={o.value} value={o.value}>{o.label}</option>
              ))}
            </select>

            <label style={s.label}>Describe tu negocio *</label>
            <textarea
              style={s.textarea}
              placeholder={`Ej: Somos una agencia inmobiliaria especializada en viviendas de lujo en el centro de Madrid. Trabajamos con compradores y vendedores desde 2010. Tenemos más de 200 propiedades activas.`}
              value={form.business_context}
              onChange={e => set('business_context', e.target.value)}
            />
            <p style={s.hint}>Cuanto más detalle, mejor responderá el agente. Puedes ampliarlo después en Configuración.</p>

            {err && <p style={s.error}>{err}</p>}
            <div style={s.btnRow}>
              <button style={s.btnSecondary} onClick={() => setStep(1)}>← Atrás</button>
              <button style={s.btnPrimary} onClick={goNext}>Siguiente →</button>
            </div>
          </>
        )}

        {/* ── PASO 3: Widget ── */}
        {step === 3 && (
          <>
            <p style={s.stepLabel}>Paso 3 de 4</p>
            <h1 style={s.title}>Instala el widget en tu web</h1>
            <p style={s.subtitle}>Copia este código y pégalo justo antes del <code style={{ color: '#7c4dff' }}>&lt;/body&gt;</code> de tu web. El chatbot aparecerá al instante.</p>

            <div style={s.codeBox} onClick={handleCopy} title="Clic para copiar">
              {widgetSnippet}
              <span style={{ position: 'absolute', top: '10px', right: '12px', fontSize: '11px', color: copied ? '#00e5a0' : '#4d6a6e' }}>
                {copied ? '✓ Copiado' : 'clic para copiar'}
              </span>
            </div>
            <p style={s.copyHint}>
              ¿Usas WordPress? Instala el plugin <strong style={{ color: '#e8f0f1' }}>Insert Headers and Footers</strong> y pega el código en el footer.
            </p>

            <div style={{ background: '#141c1e', border: '1px solid #1e2f32', borderRadius: '10px', padding: '16px 20px', marginBottom: '24px' }}>
              <p style={{ color: '#e8f0f1', fontSize: '13px', margin: '0 0 8px', fontWeight: 600 }}>También funciona en WhatsApp</p>
              <p style={{ color: '#8aa5a9', fontSize: '13px', margin: 0, lineHeight: 1.6 }}>
                Si tu plan incluye WhatsApp, configura tu número de WhatsApp Business en <strong style={{ color: '#7c4dff' }}>Configuración → WhatsApp</strong> después del wizard.
              </p>
            </div>

            <div style={s.btnRow}>
              <button style={s.btnSecondary} onClick={() => setStep(2)}>← Atrás</button>
              <button style={s.btnPrimary} onClick={goNext}>Siguiente →</button>
            </div>
          </>
        )}

        {/* ── PASO 4: Listo ── */}
        {step === 4 && (
          <>
            <p style={s.stepLabel}>Paso 4 de 4</p>
            <div style={{ textAlign: 'center' }}>
              <div style={s.successIcon}>✦</div>
              <h1 style={{ ...s.title, textAlign: 'center' }}>Todo listo</h1>
              <p style={{ ...s.subtitle, textAlign: 'center' }}>Revisa el resumen antes de activar tu agente.</p>
            </div>

            <div style={{ marginBottom: '28px' }}>
              {[
                ['Empresa',   form.nombre_empresa],
                ['Sector',    sectorLabel],
                ['Zona',      form.zona_geografica],
                ['Agente',    form.nombre_agente],
                ['Objetivo',  objetivoLabel],
              ].map(([k, v]) => (
                <div key={k} style={s.summaryRow}>
                  <span style={s.summaryKey}>{k}</span>
                  <span style={s.summaryVal}>{v}</span>
                </div>
              ))}
            </div>

            {err && <p style={s.error}>{err}</p>}
            <div style={s.btnRow}>
              <button style={s.btnSecondary} onClick={() => setStep(3)}>← Atrás</button>
              <button
                style={{ ...s.btnPrimary, opacity: saving ? 0.7 : 1 }}
                onClick={handleFinish}
                disabled={saving}
              >
                {saving ? 'Activando...' : '✦ Activar mi agente'}
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
